<template>
    <fieldset class="delivery-options co-fieldset">
        <div class="co-fieldset-inner">
            <div class="do-grid">
                <div class="do-col-one">
                    <div class="co-fullwidth-input mb-15">
                        <div>
                            <span><strong>Send Email</strong></span>
                        </div>
                        <FormulateInput
                            v-model="notify_on_order_submit"
                            type="checkbox"
                            label="My order has been received"
                        />
                        <FormulateInput
                            v-model="notify_on_new_comment"
                            type="checkbox"
                            label="When there is a new comment on the order"
                        />
                        <FormulateInput
                            v-model="notify_on_order_complete"
                            type="checkbox"
                            label="All files are ready for review or completed"
                        />
                        <FormulateInput
                            v-model="email_file_done"
                            type="checkbox"
                            label="Any one file is ready for review or completed"
                        />
                    </div>

                    <div v-if="!orderPrefs.emailsok" class="do-alert-box mb-15">
                        <alert-icon
                            title="Alert"
                            :size="20"
                            fillColor="#e1723e"
                        />
                        <p>
                            Note: all system email notifcations are disabled.
                            <a href="/settings/email"
                                >Change your email preferences</a
                            >
                            to enable system email notifciations.
                        </p>
                    </div>

                    <label class="mb-15">
                        <span><strong>Email Address(es)</strong></span>
                        <multiselect
                            v-model="emails_to_notify"
                            placeholder="Type Email and press enter to select"
                            tag-placeholder="Press enter to add email"
                            class="co-custom-arrow"
                            :options="this.formState.deliveryOptionEmails"
                            :multiple="true"
                            :taggable="true"
                            @tag="onNotifyEmail"
                        >
                            <span slot="noResult">No results found</span>
                            <template
                                slot="caret"
                                slot-scope="{ toggle }"
                                :toggle="toggle"
                            >
                                <chevron-down-icon
                                    :size="24"
                                    @mousedown.prevent.stop="toggle()"
                                    class="multiselect__select"
                                />
                            </template>
                        </multiselect>
                    </label>

                    <div class="mb-15" v-if="accountEmails">
                        <div class="bold-600">Additional Recipients:</div>
                        <div>{{ accountEmails.join(", ") }}</div>
                    </div>

                    <div class="co-fullwidth-input formulate-label-bold">
                        <FormulateInput
                            :options="nameOfActiveConnectors"
                            type="radio"
                            label="Optionally upload translation to:"
                            v-model="connector_delivery_method"
                        />
                    </div>
                </div>

                <section class="do-col-two">
                    <span class="co-label do-comments-label"
                        >Add Program Comments and Instructions</span
                    >
                    <div>
                        <acclaro-text-editor v-model="comment" />
                    </div>
                </section>
            </div>
        </div>
    </fieldset>
</template>
<script>
import "./style.scss";
import {
    CommentIcon,
    MenuIcon,
    FileIcon,
    ReceiptIcon,
    MessageTextIcon,
    AlertIcon,
    ChevronDownIcon,
} from "../../icons.js";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";

const getterSetterDeliveryOptionValue = (paramName) => {
    return {
        get() {
            return this.formState.deliveryOptions[paramName];
        },

        set(value) {
            this.setDeliveryOption({ option: paramName, value });
        },
    };
};

export default {
    props: {
        deliveryOptionsUrl: String,
    },
    data() {
        let selected = Object.assign({}, this.selected);

        return {
            isVisible: false,
            orderPrefs: {},
            accountEmails: [],
            selectedItem: selected,
            editorText: "",
        };
    },
    beforeMount() {
        //get user settings for delivery options
        this.getDeliveryOptions().then((options) => {
            let { emails, order_prefs, account_emails } = options;

            this.setDeliveryEmailOptions(emails);
            this.orderPrefs = order_prefs;
            this.accountEmails = account_emails;
            this.emails_to_notify =
                order_prefs.order_email_recipients.split(",");
        });
    },

    mounted() {
        if (window.backend.defaultEmailRecipients) {
            this.emails_to_notify = this.emails_to_notify.concat(
                window.backend.defaultEmailRecipients.split(",")
            );
        }
    },

    computed: {
        ...mapState({
            formState: (state) => state.CreateProgramStore,
        }),

        ...mapGetters("CreateProgramStore", ["deliveryOptionComment"]),
        ...mapGetters("ConnectorTilesStore", ["nameOfActiveConnectors"]),
        notify_on_order_submit: getterSetterDeliveryOptionValue(
            "notify_on_order_submit"
        ),
        notify_on_new_comment: getterSetterDeliveryOptionValue(
            "notify_on_new_comment"
        ),
        notify_on_order_complete: getterSetterDeliveryOptionValue(
            "notify_on_order_complete"
        ),
        email_file_done: getterSetterDeliveryOptionValue("email_file_done"),
        emails_to_notify: getterSetterDeliveryOptionValue("emails_to_notify"),
        connector_delivery_method: getterSetterDeliveryOptionValue(
            "connector_delivery_method"
        ),
        comment: getterSetterDeliveryOptionValue("comment"),
    },

    methods: {
        ...mapActions("CreateProgramStore", [
            "onNotifyEmail",
            "updatecomment",
            "updateDeliveryOption",
        ]),
        ...mapMutations("CreateProgramStore", ["setDeliveryOption", "setDeliveryEmailOptions", "updateDeliveryEmailOptions"]),
        /**
         * Get dropdown/select options values for
         * Order details
         *
         */
        getDeliveryOptions() {
            return axios
                .get(this.deliveryOptionsUrl)
                .then((result) => result.data);
        },
    },



    components: {
        CommentIcon,
        MenuIcon,
        FileIcon,
        ReceiptIcon,
        MessageTextIcon,
        AlertIcon,
        ChevronDownIcon,
    },

    directives: {
        ClickOutside,
    },
};
</script>
